import React from 'react'
import { useLocation, useSearchParams } from "react-router-dom"
import { sendEvent } from "./queries";
import { getRuntimeReferrer } from "./runtimeOverrides"

const EFFORTIA_TRACKING_ID: string = "G-ZXJQNF7D9V"
const VERTAAENSIN_TRACKING_ID: string = "G-YZ22BTZH9T"
const VL_TRACKING_ID: string = "G-Y3XXKHD4B6"

export function useAnalytics(){
	const [searchParams] = useSearchParams();
	let location = useLocation()

	const isLocalDev = typeof window !== "undefined" &&
		process.env.NODE_ENV === "development" &&
		(window.location.hostname === "localhost" ||
			window.location.hostname === "127.0.0.1" ||
			window.location.hostname === "[::1]")

	const runtimeReferrer = getRuntimeReferrer()
	const referrerLower = runtimeReferrer.toLowerCase()
	const referrerIsEffortia: boolean = referrerLower.includes("vakuutustenvertailu") ||
		referrerLower.includes("vakuutusvertailu") ||
		referrerLower.includes("effortia")
	const referrerIsVertaaensin: boolean = referrerLower.includes("vertaaensin")
	const selectedTrackingId = referrerIsEffortia
		? EFFORTIA_TRACKING_ID
		: (referrerIsVertaaensin ? VERTAAENSIN_TRACKING_ID : VL_TRACKING_ID)

	// React.useEffect(() => {
	// 	ReactGA.initialize(referrerIsEffortia ? EFFORTIA_TRACKING_ID : VL_TRACKING_ID, {
	// 		gaOptions: {
	// 			debug_mode: true,
	// 		},
	// 		gtagOptions: {
	// 			debug_mode: true,
	// 		},
	// 	})
	// }, [])

	React.useEffect(() => {
		if (isLocalDev) {
			console.log("[Analytics Debug]", {
				url: window.location.href,
				referrer: runtimeReferrer,
				trackingId: selectedTrackingId,
				referrerIsEffortia,
				referrerIsVertaaensin,
			})
		}
		// ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "" })

		sendEvent("", referrerIsEffortia, {
			// hitType: "pageview",
			// page: window.location.pathname,
			// title: "",
			category: "pageview",
			action: window.location.pathname,
			label: "",
			// queryId: ""
			gclid: searchParams.get("gclid") ?? ""
		})
			.catch((error) => {
				console.log("Error occurred while sending event", error)
			})
	}, [ isLocalDev, location, referrerIsEffortia, referrerIsVertaaensin, runtimeReferrer, selectedTrackingId ])
}

export default useAnalytics
